import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HeaderTabService } from '../../../shared/components/header-tabs/header-tab.service';

interface RouteItem {
  label: string;
  link: string;
  enable: boolean;
  default?: boolean;
}

@Component({
    selector: 'app-partnersequity',
    templateUrl: './partnersequity.component.html',
    styleUrls: ['./partnersequity.component.css'],
    standalone: false
})


export class PartnersequityComponent implements OnInit {

  public routes: RouteItem[];

  public isSelected = false;
  public isResponsive: boolean;

  constructor(
    private headerTabService: HeaderTabService,
    private router: Router) {
    this.routes = [
      { label: 'Socios', link: '/partnersequity/partners', enable: true },
      { label: 'Capital Social', link: '/partnersequity/capital-social', enable: true },
      { label: 'Reservas', link: '/partnersequity/reserve', enable: true },
      { label: 'Emp. del Grupo, Asoc. o Vinculados', link: '/partnersequity/related-companies', enable: true },
    ];
  }

  ngOnInit() {
    this.headerTabService.onEventSubject.subscribe(result => {
      const event = result.event;

      switch (event) {
        case 'on-select-tab':
          this.isSelected = true;
          break;
        case 'on-select-back':
          this.isSelected = false;
          break;
        case 'on-change-responsive':
          this.isResponsive = result.isResponsive;
          break;
      }
    });

  }

  public onBack() {
    this.isSelected = false;
    this.headerTabService.onEvent({ event: 'on-select-back' });
  }

}
